import $ from "jquery";

$('.menu-item-has-children > a').on('click', function(e){
  var $this = $(this);
  var $parent = $(this).parent();
  var $next = $(this).next();
  var $a = $('.menu-item-has-children');
  var $submenus = $('.sub-menu');
  if ($parent.hasClass('active')) {
    $parent.removeClass('active');
    $next.removeClass('active');
  } else {
    $a.removeClass('active');
    $submenus.removeClass('active');
    $parent.addClass('active');
    $next.addClass('active');
  }
  e.preventDefault();
});